import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-GenericLeadAfterSpecific" */'shared-components/components/GenericLeadAfterSpecific'));
